/**
 *
 * @param {string} mime
 */
export function getTypeFromMime(mime) {
  if (/image/.test(mime)) return 'image'
  else if (/audio|mp3|wav/.test(mime)) return 'audio'
  else if (/pdf/.test(mime)) return 'file'
  return 'file'
}
